import { defSetter } from "./setter";
/**
 * Unchecked version of {@link setIn}.
 *
 * @remarks
 * The type parameter `T` can be used to indicate the type of the nested
 * value to be set (default: `any`).
 *
 * @example
 * ```ts
 * setInUnsafe({}, "a.b.c", 23);
 * // { a: { b: { c: 23} } }
 * ```
 *
 * @param state -
 * @param path -
 */
export const setInUnsafe = (state, path, val) => defSetter(path)(state, val);
export function setIn(state, path, val) {
    return defSetter(path)(state, val);
}
